import script from "./SimpleDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SimpleDropdown.vue?vue&type=style&index=0&id=7fa74aef&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa74aef"]])

export default __exports__